import { GOOGLE_SHEETS_APP_ID } from 'google-sheets-integration-lib';
import { MICROSOFT_DRIVE_APP_ID } from 'microsoft-drive-integration-lib';
import { SURVEY_MONKEY_APP_ID } from 'surveymonkey-integration-lib';
import { REDDIT_ADS_APP_ID, CHATGPT_ADS_APP_ID } from 'ads-unified-auth-lib';
import enviro from 'enviro';
var ENV;
(function (ENV) {
  ENV["PROD"] = "PROD";
  ENV["QA"] = "QA";
})(ENV || (ENV = {}));
const CURRENT_ENV = enviro.isQa() ? ENV.QA : ENV.PROD;
const ZOOMINFO_APP_IDS = {
  [ENV.QA]: 31562779,
  [ENV.PROD]: 30423594
};
const SLACK_INTEGRATION_APP_IDS = {
  [ENV.QA]: 1162214,
  [ENV.PROD]: 60729
};
const ADOBE_SIGN_APP_IDS = {
  [ENV.QA]: 10021866,
  [ENV.PROD]: 3560422
};
export const getZoomInfoAppId = () => ZOOMINFO_APP_IDS[CURRENT_ENV];
export const getMicrosoftDriveAppId = () => MICROSOFT_DRIVE_APP_ID;
export const getGoogleSheetsAppId = () => GOOGLE_SHEETS_APP_ID;
export const getSlackIntegrationAppId = () => SLACK_INTEGRATION_APP_IDS[CURRENT_ENV];
export const getSurveyMonkeyAppId = () => SURVEY_MONKEY_APP_ID;
export const getRedditAdsAppId = () => REDDIT_ADS_APP_ID;
export const getChatGptAdsAppId = () => CHATGPT_ADS_APP_ID;
export const getAdobeSignAppId = () => ADOBE_SIGN_APP_IDS[CURRENT_ENV];

// Dashworks/Breeze Apps
export const INTEGRATIONS_DASHWORKS = {
  ASANA_BREEZE: 'ASANA_BREEZE',
  AZURE_DEVOPS_BREEZE: 'AZURE_DEVOPS_BREEZE',
  BOX_BREEZE: 'BOX_BREEZE',
  CONFLUENCE_BREEZE: 'CONFLUENCE_BREEZE',
  DOCUMENT360_BREEZE: 'DOCUMENT360_BREEZE',
  DROPBOX_BREEZE: 'DROPBOX_BREEZE',
  GITBOOK_BREEZE: 'GITBOOK_BREEZE',
  GMAIL_BREEZE: 'GMAIL_BREEZE',
  GOOGLE_DRIVE_BREEZE: 'GOOGLE_DRIVE_BREEZE',
  GURU_BREEZE: 'GURU_BREEZE',
  HELPJUICE_BREEZE: 'HELPJUICE_BREEZE',
  JIRA_BREEZE: 'JIRA_BREEZE',
  LINEAR_BREEZE: 'LINEAR_BREEZE',
  MSTEAMS_BREEZE: 'MSTEAMS_BREEZE',
  ONEDRIVE_BREEZE: 'ONEDRIVE_BREEZE',
  OUTLOOK_BREEZE: 'OUTLOOK_BREEZE',
  PRODUCTBOARD_BREEZE: 'PRODUCTBOARD_BREEZE',
  README_BREEZE: 'README_BREEZE',
  SHAREPOINT_BREEZE: 'SHAREPOINT_BREEZE',
  SLACK_BREEZE: 'SLACK_BREEZE',
  SMARTSHEET_BREEZE: 'SMARTSHEET_BREEZE',
  STACKOVERFLOW_TEAMS_BREEZE: 'STACKOVERFLOW_TEAMS_BREEZE'
};
export const DASHWORKS_APPS_DATA = {
  [INTEGRATIONS_DASHWORKS.ASANA_BREEZE]: {
    displayName: 'Asana (for Breeze)',
    appIds: {
      QA: 21361649,
      PROD: 15757528
    }
  },
  [INTEGRATIONS_DASHWORKS.AZURE_DEVOPS_BREEZE]: {
    displayName: 'Azure DevOps (for Breeze)',
    appIds: {
      QA: 20332460,
      PROD: 14658526
    }
  },
  [INTEGRATIONS_DASHWORKS.BOX_BREEZE]: {
    displayName: 'Box (for Breeze)',
    appIds: {
      QA: 21361762,
      PROD: 16147293
    }
  },
  [INTEGRATIONS_DASHWORKS.CONFLUENCE_BREEZE]: {
    displayName: 'Confluence (for Breeze)',
    appIds: {
      QA: 19956024,
      PROD: 14114216
    }
  },
  [INTEGRATIONS_DASHWORKS.DROPBOX_BREEZE]: {
    displayName: 'Dropbox (for Breeze)',
    appIds: {
      QA: 21361684,
      PROD: 16147236
    }
  },
  [INTEGRATIONS_DASHWORKS.GMAIL_BREEZE]: {
    displayName: 'Gmail (for Breeze)',
    appIds: {
      QA: 19767525,
      PROD: 13823852
    }
  },
  [INTEGRATIONS_DASHWORKS.GOOGLE_DRIVE_BREEZE]: {
    displayName: 'Google Drive (for Breeze)',
    appIds: {
      QA: 19768331,
      PROD: 13824211
    }
  },
  [INTEGRATIONS_DASHWORKS.JIRA_BREEZE]: {
    displayName: 'Jira (for Breeze)',
    appIds: {
      QA: 20331833,
      PROD: 14657622
    }
  },
  [INTEGRATIONS_DASHWORKS.LINEAR_BREEZE]: {
    displayName: 'Linear (for Breeze)',
    appIds: {
      QA: 21559382,
      PROD: 16432607
    }
  },
  [INTEGRATIONS_DASHWORKS.MSTEAMS_BREEZE]: {
    displayName: 'Microsoft Teams (for Breeze)',
    appIds: {
      QA: 19768560,
      PROD: 13823956
    }
  },
  [INTEGRATIONS_DASHWORKS.ONEDRIVE_BREEZE]: {
    displayName: 'OneDrive (for Breeze)',
    appIds: {
      QA: 19768777,
      PROD: 13824019
    }
  },
  [INTEGRATIONS_DASHWORKS.OUTLOOK_BREEZE]: {
    displayName: 'Outlook (for Breeze)',
    appIds: {
      QA: 19768635,
      PROD: 13824166
    }
  },
  [INTEGRATIONS_DASHWORKS.PRODUCTBOARD_BREEZE]: {
    displayName: 'Productboard (for Breeze)',
    appIds: {
      QA: 21741290,
      PROD: 16628418
    }
  },
  [INTEGRATIONS_DASHWORKS.SHAREPOINT_BREEZE]: {
    displayName: 'SharePoint (for Breeze)',
    appIds: {
      QA: 19768705,
      PROD: 13824042
    }
  },
  [INTEGRATIONS_DASHWORKS.SLACK_BREEZE]: {
    displayName: 'Slack (for Breeze)',
    appIds: {
      QA: 19764048,
      PROD: 13697285
    }
  },
  [INTEGRATIONS_DASHWORKS.SMARTSHEET_BREEZE]: {
    displayName: 'Smartsheet (for Breeze)',
    appIds: {
      QA: 21559054,
      PROD: 16432527
    }
  },
  [INTEGRATIONS_DASHWORKS.DOCUMENT360_BREEZE]: {
    displayName: 'Document360 (for Breeze)',
    appIds: {
      QA: 22050238,
      PROD: 17045734
    }
  },
  [INTEGRATIONS_DASHWORKS.GITBOOK_BREEZE]: {
    displayName: 'GitBook (for Breeze)',
    appIds: {
      QA: 22050242,
      PROD: 17045735
    }
  },
  [INTEGRATIONS_DASHWORKS.GURU_BREEZE]: {
    displayName: 'Guru (for Breeze)',
    appIds: {
      QA: 21714619,
      PROD: 16617295
    }
  },
  [INTEGRATIONS_DASHWORKS.HELPJUICE_BREEZE]: {
    displayName: 'Helpjuice (for Breeze)',
    appIds: {
      QA: 22050244,
      PROD: 17045736
    }
  },
  [INTEGRATIONS_DASHWORKS.README_BREEZE]: {
    displayName: 'ReadMe (for Breeze)',
    appIds: {
      QA: 22050245,
      PROD: 17045737
    }
  },
  [INTEGRATIONS_DASHWORKS.STACKOVERFLOW_TEAMS_BREEZE]: {
    displayName: 'Stack Overflow for Teams (for Breeze)',
    appIds: {
      QA: 22050247,
      PROD: 17045740
    }
  }
};
export const INTEGRATIONS = Object.assign({}, DASHWORKS_APPS_DATA);
export const getAppIdByAppName = appName => INTEGRATIONS[appName].appIds[CURRENT_ENV];